import React from 'react';
import PropTypes from 'prop-types';

import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../../Common/Header/header';
import ShelfLifeUpdateViewGrid from './ShelfLifeUpdateViewGrid/shelfLifeUpdateViewGrid';
import {PL_DialogWrapper}  from 'infrastructure/js/components/Dialog/dialog';
import CreateReasonTypeDialog from './Dialogs/CreateReasonTypeDialog/createReasonTypeDialog';
import {MatSettingsMenuItemsIds} from '../../../../../enums/navigationMenuItemsIds';

export default class ShelfLifeUpdateView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.reasons.shelflife.view.');
  }

  componentDidMount() {
    this.props.actions.init(false);
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_REASONS_SHELF_LIFE_UPDATE);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {

      buttons: [
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onCreateReasonTypeClick,
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
          disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onEditReasonTypeClick,
          actionData: selectedRowsData.get(0)
        }
      ],

      kebab: {
        disabled: !selectedRowsData || selectedRowsData.size === 0,
        menuItems: [
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemoveReasonClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData: selectedRowsData
          }
        ]
      }
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems}/>

        <ShelfLifeUpdateViewGrid actions={this.props.actions.shelfLifeUpdateViewGridActions} />

        <PL_DialogWrapper dialogComponent={CreateReasonTypeDialog}
                          show={this.props.sCreateReasonTypeDialogData.get('show')}
                          actions={this.props.actions.createReasonTypeDialogActions}
                          sData={this.props.sCreateReasonTypeDialogData}
                          reloadParentComponent={this.reloadPage}
        />

      </div>
    );
  }
}

ShelfLifeUpdateView.propTypes = {
  sGrid: PropTypes.object
};

